import { render, staticRenderFns } from "./ContractCirculationApproval.vue?vue&type=template&id=51544ace&scoped=true&"
import script from "./ContractCirculationApproval.vue?vue&type=script&lang=js&"
export * from "./ContractCirculationApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51544ace",
  null
  
)

export default component.exports